export default {
  description: {
    marginTop: '8px',
    fontWeight: 'bold',
  },
};
